/**
 * Set by the welcome page once its link is used: setup opens on "How you'll
 * sign in next time", since the person has no way to sign in yet but the link.
 * Session storage, so it lasts for this tab only.
 */
export const WELCOME_SIGN_IN_STEP = 'cadence_welcome_signin';
